export default __webpack_public_path__ + "static/media/Affrescati_dettagli_segno_manuale_01.943b2f63.jpg";